import { z } from 'zod';

export const platformTimeLogEntrySchema = z.object({
  id: z.string().min(1).max(160),
  workDate: z.iso.date(),
  hours: z.number().positive().max(24).multipleOf(0.01),
  description: z.string().trim().min(1).max(500).optional(),
  category: z.string().trim().min(1).max(80).optional(),
  project: z.string().trim().min(1).max(120).optional(),
  source: z.enum(['manual', 'timer']).default('manual'),
  createdBy: z.string().min(1),
  createdByEmail: z.email().optional(),
  createdAt: z.string().datetime(),
  updatedBy: z.string().min(1).optional(),
  updatedAt: z.string().datetime().optional(),
});

export type PlatformTimeLogEntry = z.infer<typeof platformTimeLogEntrySchema>;

export const createPlatformTimeLogEntrySchema = platformTimeLogEntrySchema
  .pick({
    workDate: true,
    hours: true,
    description: true,
    category: true,
    project: true,
  })
  .refine((value) => Number.isInteger(value.hours * 4), {
    message: 'Manual time must be entered in 15-minute increments',
    path: ['hours'],
  });

export type CreatePlatformTimeLogEntry = z.infer<typeof createPlatformTimeLogEntrySchema>;

export const updatePlatformTimeLogEntrySchema = z
  .object({
    description: z.string().trim().min(1).max(500).nullable().optional(),
    category: z.string().trim().min(1).max(80).nullable().optional(),
    project: z.string().trim().min(1).max(120).nullable().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, 'At least one field must be updated');
export type UpdatePlatformTimeLogEntry = z.infer<typeof updatePlatformTimeLogEntrySchema>;

export const platformTimeTimerSchema = z.object({
  id: z.string().min(1).max(160),
  status: z.enum(['running', 'stopped']),
  description: z.string().trim().min(1).max(500).optional(),
  category: z.string().trim().min(1).max(80).optional(),
  project: z.string().trim().min(1).max(120).optional(),
  startedBy: z.string().min(1),
  startedByEmail: z.email().optional(),
  startedAt: z.string().datetime(),
  stoppedAt: z.string().datetime().optional(),
  entryId: z.string().min(1).max(160).optional(),
});
export type PlatformTimeTimer = z.infer<typeof platformTimeTimerSchema>;

export const startPlatformTimeTimerSchema = platformTimeTimerSchema.pick({
  description: true,
  category: true,
  project: true,
});
export type StartPlatformTimeTimer = z.infer<typeof startPlatformTimeTimerSchema>;

export const platformTimeLogListSchema = z.object({
  items: z.array(platformTimeLogEntrySchema),
});
